<template>
  <b-modal
    size="lg"
    hide-footer
    v-model="show"
    :title="`Edição da Configuração`"
    @hidden="cancelar"
  >
    <b-card>
      <b-row>
        <b-col cols="12">
          <div>
            <span class="font-weight-bold">Configuração:</span> {{ configuracao.tituloPropriedade }}
          </div>
        </b-col>
      </b-row>
    </b-card>
    <b-form @submit.prevent="salvar">
      <b-form-row>
        <b-col cols="12">
          <b-form-group>
            <lg-form-input
              id="dias-input"
              v-model.number="form.dias"
              type="number"
              label="Dias:"
              min="0"
              required
              placeholder="Digite o número de dias"
            />
          </b-form-group>
        </b-col>
        <b-col cols="12">
          <b-form-group>
            <lg-form-select
              v-model="form.frequencia"
              :loadFunction="loadFrequenciaList"
              labelFormGroupBind="Frequência:"
              label="descricao"
              :description="''"
              :filterList="false"
              required
            />
          </b-form-group>
        </b-col>
        <b-col cols="12">
          <b-form-group>
            <lg-form-date
              id="inicio-date"
              v-model="form.inicio"
              required
              placeholder="Selecione a data de início"
              label="Início:"
            />
          </b-form-group>
        </b-col>
        <b-col cols="12">
          <b-form-group>
            <lg-form-textarea
              id="mensagem-textarea"
              label="Mensagem:"
              v-model="form.mensagem"
              :rows="3"
              placeholder="Digite a mensagem de alerta"
              required
            />
          </b-form-group>
        </b-col>
      </b-form-row>
      <b-form-row class="d-flex justify-content-center">
        <b-button type="submit" size="sm" pill variant="success">
          <b-icon icon="check-circle" />
        </b-button>
        <b-button size="sm" pill variant="danger" @click="cancelar" class="ml-2">
          <b-icon icon="x-circle" />
        </b-button>
      </b-form-row>
    </b-form>
  </b-modal>
</template>

<script>
import LgFormInput from "@/core/components/Form/LgFormInput.vue";
import LgFormDate from "@/core/components/Form/LgFormDate.vue";
import LgFormSelect from "@/core/components/Form/LgFormSelect.vue";
import LgFormTextarea from "@/core/components/Form/LgFormTextarea.vue";
import ConfiguracaoSistemaService from "@/core/api/ConfiguracaoSistemaService";
import Swal from "sweetalert2";
import { FREQUENCIA_OPTIONS } from "@/constants/frequencyOptions";

export default {
  components: {
    LgFormTextarea,
    LgFormInput,
    LgFormDate,
    LgFormSelect,
  },
  props: {
    configuracao: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      show: true,
      form: {
        dias: 0,
        frequencia: null, // Armazena o código numérico
        inicio: null,
        mensagem: "",
      },
      frequenciasOptions: FREQUENCIA_OPTIONS, // Importa as opções mapeadas
    };
  },
  methods: {
    async loadFrequenciaList() {
      return {
        data: {
          content: this.frequenciasOptions,
          totalPages: 1
        }
      };
    },
    async salvar() {
      if (
        this.form.dias === null ||
        this.form.frequencia === null ||
        !this.form.inicio ||
        this.form.mensagem.trim() === ""
      ) {
        this.$bvToast.toast("Preencha todos os campos obrigatórios", {
          title: "Erro",
          variant: "danger",
          solid: true,
        });
        return;
      }

      const valorPropriedade = [
        this.form.dias,
        this.form.frequencia.value,
        this.form.mensagem.trim(),
        this.form.inicio,
      ].join(";");

      const payload = {
        id: this.configuracao.id,
        valorPropriedade,
      };

        await ConfiguracaoSistemaService.atualizarConfiguracao(payload);
        this.$emit("salvo");
        await Swal.fire({
          title: "Sucesso",
          text: "Configuração salva com sucesso!",
          icon: "success",
          confirmButtonText: "OK",
        });
      
    },
    cancelar() {
      this.$emit("close");
    },
    carregarDadosIniciais() {
      if (this.configuracao.valorPropriedade) {
        const valores = this.configuracao.valorPropriedade.split(";");
        this.form.dias = parseInt(valores[0], 10) || 0;
        this.form.frequencia = FREQUENCIA_OPTIONS.find(f=> f.value == parseInt(valores[1], 10))|| null; 
        this.form.mensagem = valores[2] || "";
        this.form.inicio = valores[3] || null;
      }
    },
  },
  mounted() {
    this.carregarDadosIniciais();
  },
};
</script>

<style scoped>
.font-weight-bold {
  font-weight: bold;
}
</style>
